import React from 'react'
import Skeleton from 'react-loading-skeleton'

export const AuthSkeleton: React.FC = () => {
  return (
    <span>
      <Skeleton width="50%" height={48} />
      <Skeleton width="50%" height={48} />
    </span>
  )
}
